import { Flex } from "@acko-tech/building-blocks.ui.common";
import { Price } from "@acko-tech/building-blocks.ui.typography";
import RadioSelection from "@components/common/radioSelection";
import {
    CoverItem,
    DropdownContainer,
    IDVHeading,
    IDVSectionHeading,
    SectionHeader
} from "@widgets/coveragePricingBreakup/styles";
import ArrowUp from "@public/images/arrow-up.svg";
import ArrowDown from "@public/images/arrow-down.svg";
import { connect } from "react-redux";
import { getWidgetSpecificProps } from "@utils/index";
import DOMPurify from "isomorphic-dompurify";
import { useEffect, useRef, useState } from "react";
import { Router, useRouter } from "next/router";
import { BasicLoader } from "@acko-tech/building-blocks.ui.loaders";
import ImageContainer from "@components/imageContainer";
import { analyticEvents as triggerAnalyticEvent } from "@actions/analyticEvents";
import _ from "lodash";
import { TextWrapper } from "@widgets/reviewSelectedPlan/styles";
import { getRequestpayload } from "@utils/index";

const mapStateToProps = function (state: any, ownProps: any) {
    return getWidgetSpecificProps(
        state.configuration?.normalisedConfig,
        ownProps.id
    );
};

const ReviewAdditionalCovers = (props) => {
    const {
        setExpanded,
        expanded,
        is_visible,
        additional_covers_text,
        addtionalCovers,
        actions,
        arrowUpSrc,
        arrowDownSrc,
        showAddonToggle,
        showExpandableIcon
    } = props || {};

    const { on_addon_update } = actions || {};
    const router = useRouter();
    const { proposal_ekey } = router?.query;
    const [isLoading, setIsLoading] = useState(false);
    const [currentAddons, setCurrentAddons] = useState<any>([]);
    const prevAddtionalCoversRef = useRef([]);

    const toggleCover = async (id: string) => {
        try {
            setIsLoading(true);

            const updateAddonFunction = on_addon_update?.[0];
            const addonToBeUpdated = currentAddons.filter((cover: any) => {
                if (cover?.id === id) {
                    return cover;
                }
            })[0];

            const args = {
                interaction: addonToBeUpdated?.isAdded ? "remove" : "add",
                proposal_ekey: proposal_ekey,
                id: addonToBeUpdated?.id,
                variant_id: addonToBeUpdated?.variant_id || ""
            };

            const payload = {
                ...updateAddonFunction.args,
                ...args
            };

            if (
                updateAddonFunction &&
                typeof updateAddonFunction.funCall === "function"
            ) {
                const response = await updateAddonFunction.funCall(payload || {});

                const { premium, plan_details } = response || {};
                const { premium_data, total_premium_data } = plan_details;
                const { total_premium, total_value_including_gst } = premium;
                const planUpdatedProps = {
                    ...plan_details,
                    premiumData: premium_data,
                    totalPremiumData: total_premium_data
                };
                const updateTotalPremium = {
                    ...premium,
                    premiumDetails: total_premium,
                    grossPremium: total_value_including_gst
                };

                const footerPrice = {
                    price: total_value_including_gst
                };
                const updatedProps = [
                    planUpdatedProps,
                    updateTotalPremium,
                    footerPrice
                ];

                const updateNormalisedData = on_addon_update?.[1];
                const customPayload = {
                    ...updateNormalisedData.args,
                    updatedProps
                };
                if (
                    updateNormalisedData &&
                    typeof updateNormalisedData.funCall === "function"
                ) {
                    updateNormalisedData.funCall(customPayload || {});
                }
            }

            const { data, journey } = getRequestpayload();
            const filterAddons = currentAddons?.map((cover) => {
                if (cover?.id === id) {
                    return {
                        ...cover,
                        isAdded: !cover.isAdded
                    };
                }
                return cover;
            });
            setCurrentAddons(filterAddons);
            await triggerAnalyticEvent({
                edata: {
                    product: data.product,
                    action_name: addonToBeUpdated?.isAdded
                        ? "tap_btn_add_on_removed"
                        : "tap_btn_coupon_added",
                    action_type: "tap_btn",
                    add_on_id: addonToBeUpdated?.id
                },
                odata: {
                    journey
                },
                event_name: "action"
            });
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (!_.isEqual(prevAddtionalCoversRef.current, addtionalCovers)) {
            prevAddtionalCoversRef.current = addtionalCovers; // Store the latest value
            const addonsWithSelectedState = addtionalCovers.map((cover) => ({
                ...cover,
                isAdded: true
            }));
            setCurrentAddons(addonsWithSelectedState);
        }
    }, [addtionalCovers]);

    if (!is_visible) {
        return null;
    }

    const coversAdded = currentAddons?.length > 0;
    return (
        <>
            {isLoading ? <BasicLoader /> : null}
            {coversAdded ? (
                <>
                    <SectionHeader style={{ paddingBottom: "0px" }}>
                        <IDVHeading>{additional_covers_text}</IDVHeading>
                    </SectionHeader>
                    <Flex
                        flexDirection="column"
                        style={{ paddingBottom: "8px", boxSizing: "border-box" }}
                    >
                        {currentAddons?.map((cover) => {
                            const { id, key, description, value, isAdded } = cover || {};
                            return (
                                <CoverItem
                                    key={id}
                                    onClick={() =>
                                        showExpandableIcon && setExpanded((prev) => (prev === id ? false : id))
                                    }
                                >
                                    <Flex
                                        style={{
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            flexWrap: "nowrap"
                                        }}
                                    >
                                        <Flex
                                            style={{
                                                alignItems: "flex-start",
                                                flexGrow: 1,
                                                gap: "4px",
                                                minWidth: 0,
                                                display: "flex"
                                            }}
                                        >
                                            {
                                                showAddonToggle ? <RadioSelection
                                                    clickHandler={() => {
                                                        toggleCover(id);
                                                    }}
                                                    selected={isAdded}
                                                /> : null
                                            }

                                            <TextWrapper>
                                                <Flex>
                                                    <IDVSectionHeading
                                                        style={{
                                                            fontSize: "14px",
                                                            fontWeight: "500px",
                                                            marginLeft: showAddonToggle ? "4px" : "0px",
                                                            flexWrap: "wrap",
                                                            color: "#040222",
                                                            position: "relative",
                                                            display: "flex"
                                                        }}
                                                    >
                                                        <span>{key}</span>
                                                        {

                                                            showExpandableIcon ? <div
                                                                style={{
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    maxWidth: "20px",
                                                                    maxHeight: "20px",
                                                                    marginLeft: "4px",
                                                                    position: "absolute",
                                                                    right: "-20px"
                                                                }}
                                                            >
                                                                {expanded === id ? (
                                                                    <ImageContainer
                                                                        imgSrc={arrowUpSrc}
                                                                        width={20}
                                                                        height={20}
                                                                    />
                                                                ) : (
                                                                    <ImageContainer
                                                                        imgSrc={arrowDownSrc}
                                                                        width={20}
                                                                        height={20}
                                                                    />
                                                                )}
                                                            </div> : null
                                                        }

                                                    </IDVSectionHeading>
                                                </Flex>
                                            </TextWrapper>
                                        </Flex>
                                        <Price
                                            style={{
                                                textDecoration: isAdded ? "none" : "line-through",
                                                color: isAdded ? "black" : "gray"
                                            }}
                                        >
                                            {value}
                                        </Price>
                                    </Flex>
                                    <DropdownContainer expanded={expanded === id}>
                                        <p
                                            style={{
                                                fontSize: "12px",
                                                color: "#5B5675",
                                                fontWeight: 400,
                                                lineHeight: "18px",
                                                marginTop: "8px",
                                                marginBottom: "0px"
                                            }}
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(description)
                                            }}
                                        ></p>
                                    </DropdownContainer>
                                </CoverItem>
                            );
                        })}
                    </Flex>
                </>
            ) : null}
        </>
    );
};

export default connect(mapStateToProps)(ReviewAdditionalCovers);
